import { useEffect } from 'react';
import userAgentDetect from '../../util/userAgentDetect';
import { NEW_RELIC_CONFIG } from '../../constants/newRelic';

export const InitializeNewRelic = () => {
  useEffect(() => {
    async function SetupNewRelic() {
      const { BrowserAgent } = await import(
        '@newrelic/browser-agent/loaders/browser-agent'
      );

      // The agent loader code executes immediately on instantiation.
      /*
       * NOTE: This will be replaced by the initializeNewRelicAgent method of om-newrelic-tracker
       *   when ready.
       */
      // eslint-disable-next-line no-new
      new BrowserAgent(NEW_RELIC_CONFIG);
    }

    const isCypressUserAgent = userAgentDetect('Cypress');
    if (
      typeof window !== 'undefined' &&
      !isCypressUserAgent &&
      process.env.NODE_ENV === 'production'
    ) {
      SetupNewRelic();
    }
  }, []);

  return null;
};
